<template>
  <div class="box-detail">
    <div class="box-left">
      <!-- 导航注释 -->
      <!--  <div class="box-left-header-contact" style="height:50px;">
        <div @click="$router.push({ path: '/ServiceTerritoriesCustom' })" class="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>新版服务区域</span>
         <i class="el-icon-place"></i> 
        </div>
      </div>-->
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          labelWidth="110px"
          :area="area"
          @changeForm="osg.changeForm"
        >
          <template slot="area">
            <el-cascader
              v-if="area.show"
              :options="area.options"
              :props="area.props"
              v-model="formData.area"
              collapse-tags
              clearable
            ></el-cascader>
          </template>
          <template slot="keywords">
            <el-input v-model="formData.keywords" placeholder="请输入关键词"></el-input>
          </template>
        </c-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <!-- 动态 笔记 -->
    <div class="box-center">
      <el-tabs v-model="activeTab" class="c-h-1 c-flex c-flex-col">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">{{ log.content }}</div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.createUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="业务跟踪"
          name="bizStackTraceSA"
          v-if="osg.has('ServiceTerritoryCustom,exception')"
        >
          <bizStackTrace :params="{ sid: id }" v-if="id"></bizStackTrace>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <span>平台绑定服务资源</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="addSR">
                添加服务资源
              </el-button>
            </template>
            <div class="card-group">
              <!-- <div class="c-blue c-m-b-10">
                <i class="el-icon-info c-m-r-10"></i>
                <span>可拖拽服务资源，调整优先分单顺序。</span>
              </div> -->
              <!-- <draggable v-model="ServiceResource.relatedData" @end="dragEnd"> -->
              <!-- <transition-group> -->
              <div class="card-item" v-for="(item, i) of ServiceResource.bindRelatedData" :key="i">
                <div class="c-m-r-10">
                  {{ i + 1 + '.' }}
                </div>
                <div>
                  <el-link
                    @click="osg.open('', '', '_blank', '/ServiceResource/' + item._id)"
                    target="_blank"
                  >
                    资源名称：{{ item.name }}
                  </el-link>
                  <p>资源类型：{{ osg.codelabel('resourceType', item.resourceType) }}</p>
                  <p>服务类型：{{ osg.codelabelForArray('serviceType', item.serviceType) }}</p>
                </div>
                <!-- 至少保留1个服务资源 -->
                <i
                  v-if="ServiceResource.bindRelatedData.length > 1"
                  class="el-icon-close card-item-icon-remove"
                  @click="cancelSR(item, i)"
                ></i>
              </div>
              <!-- </transition-group> -->
              <!-- </draggable> -->
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <span>自绑定服务资源</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of ServiceResource.relatedData" :key="i">
                <div class="c-m-r-10">
                  {{ i + 1 + '.' }}
                </div>
                <div>
                  <el-link
                    @click="osg.open('', '', '_blank', '/ServiceResource/' + item._id)"
                    target="_blank"
                  >
                    资源名称：{{ item.name }}
                  </el-link>
                  <p>资源类型：{{ osg.codelabel('resourceType', item.resourceType) }}</p>
                  <p>服务类型：{{ osg.codelabelForArray('serviceType', item.serviceType) }}</p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <span>扩充服务区域</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="addSTC">
                扩充服务区域
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of extendST.extendData" :key="i">
                <div class="c-m-r-10">
                  {{ i + 1 + '.' }}
                </div>
                <div>
                  <el-link
                    @click="osg.open('', '', '_blank', '/ServiceTerritoryCustom/' + item._id)"
                    target="_blank"
                  >
                    区域名称：{{ item.name }}
                  </el-link>
                  <p>区域编号：{{ item.territoryNum }}</p>
                  <p>服务类型：{{ osg.codelabelForArray('serviceType', item.serviceType) }}</p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="cancelSTC(item)"></i>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <el-drawer
      custom-class="c-drawer"
      title="平台绑定服务资源"
      :visible.sync="ServiceResource.openRelate"
      direction="rtl"
    >
      <div class="el-drawer__content">
        <el-tabs v-model="ServiceResource.activeName" type="card">
          <el-tab-pane label="选择已有服务资源" name="search">
            <el-select
              v-model="ServiceResource.ids"
              filterable
              remote
              reserve-keyword
              multiple
              placeholder="搜索服务资源名称"
              suffix-icon="el-icon-date"
              :remote-method="searchSR"
              clearable
              @clear="searchSR"
              :loading="false"
              @change="$forceUpdate()"
              class="c-w-1"
            >
              <el-option
                v-for="(item, index) in ServiceResource.data"
                :key="item._id + index"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="el-drawer__footer">
        <el-button
          type="primary"
          @click="
            bindSR();
            initSR();
          "
        >
          保存
        </el-button>
        <el-button
          plain
          @click="
            getData();
            initSR();
          "
        >
          取消
        </el-button>
      </div>
    </el-drawer>

    <el-drawer
      custom-class="c-drawer"
      title="扩充服务区域"
      :visible.sync="extendST.show"
      direction="rtl"
    >
      <div class="el-drawer__content">
        <el-tabs v-model="extendST.activeName" type="card">
          <el-tab-pane label="选择已有服务区域" name="search">
            <el-select
              v-model="extendST.ids"
              filterable
              remote
              reserve-keyword
              multiple
              placeholder="搜索服务区域名称"
              suffix-icon="el-icon-date"
              :remote-method="searchSTC"
              clearable
              @clear="searchSTC"
              :loading="false"
              @change="$forceUpdate()"
              class="c-w-1"
            >
              <el-option
                v-for="(item, index) in extendST.data"
                :key="item._id + index"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="el-drawer__footer">
        <el-button
          type="primary"
          @click="
            bindSTC();
            initSTC();
          "
        >
          保存
        </el-button>
        <el-button
          plain
          @click="
            getData();
            initSTC();
          "
        >
          取消
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
import draggable from 'vuedraggable';
export default {
  activated() {
    window.$this = this;
  },
  components: {
    draggable,
    bizStackTrace: () => import('../../components/bizStackTrace')
  },
  name: 'serviceTerritoryCustom',
  data() {
    window.$this = this;
    let that = this;
    return {
      savedStreet: '', //row中已保存的街道
      // gitSame: [], //相同数据
      gitDiff: [], // 不同数据
      doSaveDisableArr: [], //编辑确定后勾选中的街道
      notdDisableArr: [], //编辑时街道数据
      id: null,
      tenantId: '',
      collapse: false,
      formData: { exts: {}, foundTime: '', serviceType: [] },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      fpi: {},
      options: {
        codecfg_resourceType: { codeId: 'resourceType' },
        codecfg_serviceType: { codeId: 'serviceType' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址级联
      areaList: this.$util.deepCopy(this.osg.areaList),
      area: {
        options: this.areaList,
        show: true,
        props: {
          multiple: true,
          lazy: true,
          async lazyLoad(node, resolve) {
            const { level } = node;
            var nodes = [];
            if (level == '3') {
              node.data.leaf = false;
              if (node.children && node.children.length == 0) {
                node.children = [];
                let id = node.data.value;
                await that.getDataAllStreet();
                let arr = that.subdistrictT.concat(that.doSaveDisableArr, that.gitDiff);
                nodes = await that.$util.getSubdistrict(
                  id,
                  arr,
                  that.savedStreet,
                  'areaTranslation'
                );
                if (nodes.length == 0) {
                  node.data.leaf = true;
                }
              }
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        }
      },
      //服务资源
      ServiceResource: {
        ids: [],
        data: [],
        bindRelatedData: [],
        relatedData: [],
        openRelate: false,
        activeName: 'search'
      },
      activeNames: ['1', '2', '3'],
      subdistrictT: [], //数据中的街道
      // 扩充服务区域
      extendST: {
        show: false,
        ids: [],
        data: [],
        extendData: [],
        activeName: 'search'
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  beforeCreate() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.osg.getFields('serviceTerritoryCustom', () => {
      this.getData();
    });
    this.getNote();
    this.getHistory();
  },
  methods: {
    // 请求全部数据中已保存的街道，用于判断街道去重
    getDataAllStreet() {
      return new Promise(resolve => {
        var params = {
          _all: '1',
          'in:state|array-integer#and': '0,1',
          'regex:name|string#or': this.searchValue,
          'in:serviceType|array#and': this.formData.serviceType.join(),
          sortField: 'territoryNum,createTime',
          sortOrder: 'asc'
        };
        //添加过滤器参数
        this.osg.setFpi(params);
        this.osg.ajax('basic/serviceTerritoryCustom/query.do', params, res => {
          res.data.map(item => {
            this.subdistrictT = this.subdistrictT.concat(...item.subdistrict);
          });
          resolve(res.data);
        });
      });
    },
    getData() {
      this.osg.ajax(`basic/serviceTerritoryCustom/queryById/${this.id}.do`, {}, res => {
        let row = res.data;
        this.$util.renderExtField(this.extFields, row);
        if (this.$util.isJson(row.area)) {
          row.area = JSON.parse(row.area);
        }
        // 往区插入下级街道数据
        let districts = [];
        let addDistricts = [];
        row.area.map(area => {
          if (area.length == 4 && districts.indexOf(area[2]) == -1) {
            districts.push(area[2]);
            addDistricts.push(area);
          }
        });
        if (districts.length > 0) {
          this.getSubdistricts(districts, subdistricts => {
            this.addSubdistricts(addDistricts, subdistricts, row);
            this.area.show = false;
            this.formData = row;
            this.$nextTick(() => {
              this.area.show = true;
              this.getBindRelatedSR();
              this.getRelatedSR();
              this.getExtendSTC();
              this.searchSR();
              this.searchSTC();
            });
          });
        } else {
          this.area.show = false;
          this.formData = row;
          this.$nextTick(() => {
            this.area.show = true;
            this.getBindRelatedSR();
            this.getRelatedSR();
            this.getExtendSTC();
            this.searchSR();
            this.searchSTC();
          });
        }
        this.getLog();
      });
    },
    getSubdistricts(districts, callback) {
      this.osg.ajax(
        'area/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterTenantId: '1',
          'in:parentCode|array#and': districts.join(),
          level: '4',
          sortField: 'code',
          sortOrder: 'asc'
        },
        res => {
          res.data.map(item => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = true;
          });
          if (callback) {
            callback(res.data);
          }
        },
        {
          noload: true
        }
      );
    },
    addSubdistricts(areaList, subdistricts, row) {
      this.notdDisableArr = row.area.map((item, index) => row.area[index][3]);
      areaList.map(area => {
        for (let i = 0; i < this.areaList.length; i++) {
          let province = this.areaList[i];
          if (province.value == area[0]) {
            for (let j = 0; j < province.children.length; j++) {
              let city = province.children[j];
              if (city.value == area[1]) {
                for (let k = 0; k < city.children.length; k++) {
                  let district = city.children[k];
                  if (district.value == area[2]) {
                    district.children = [];
                    district.leaf = false;
                    subdistricts.map(subdistrict => {
                      subdistrict.disabled =
                        !this.gitDiff.includes(subdistrict.value) &&
                        !this.notdDisableArr.includes(subdistrict.value) &&
                        this.subdistrictT.indexOf(subdistrict.value) !== -1;
                      this.savedStreet = row.subdistrict;
                      if (subdistrict.parentCode == district.value) {
                        district.children.push(subdistrict);
                      }
                    });
                    break;
                  }
                }
                break;
              }
            }
            break;
          }
        }
      });
    },
    getBindRelatedSR() {
      if (this.formData.bindRelatedIds.length == 0) {
        this.ServiceResource.bindRelatedData = [];
        return;
      }
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:_id|array#and': this.formData.bindRelatedIds.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.ServiceResource.bindRelatedData = res.data;
        },
        {
          noload: true
        }
      );
    },
    getRelatedSR() {
      if (this.formData.relatedIds.length == 0) {
        this.ServiceResource.relatedData = [];
        return;
      }
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:_id|array#and': this.formData.relatedIds.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.ServiceResource.relatedData = res.data;
        },
        {
          noload: true
        }
      );
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);

        //省市区支持多选
        params.area = params.area || [];
        let province = [];
        let city = [];
        let district = [];
        let subdistrict = [];
        for (let item of params.area) {
          if (province.indexOf(item[0]) == -1) province.push(item[0]);
          if (city.indexOf(item[1]) == -1) city.push(item[1]);
          if (district.indexOf(item[2]) == -1) district.push(item[2]);
          if (subdistrict.indexOf(item[3]) == -1) subdistrict.push(item[3]);
        }
        params.province = province;
        params.city = city;
        params.district = district;
        params.subdistrict = subdistrict;
        params.area = JSON.stringify(params.area);

        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax(
          'basic/serviceTerritoryCustom/upsert.do',
          { data: JSON.stringify(params) },
          res => {
            this.doSaveDisableArr = res.data.subdistrict;
            // 找不同元素
            this.gitDiff = this.notdDisableArr
              .concat(this.doSaveDisableArr)
              .filter((item, index, arr) => arr.indexOf(item) === arr.lastIndexOf(item));
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'serviceTerritoryCustom',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'serviceTerritoryCustom'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    //保存笔记
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'serviceTerritoryCustom',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatResourceType(cellValue) {
      //反显资源类型
      return this.osg.codelabel('resourceType', cellValue);
    },
    initSR() {
      this.ServiceResource.openRelate = false;
      this.ServiceResource.ids = [];
    },
    // 搜索服务资源
    searchSR(query) {
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          page: 1,
          rows: 20,
          'is:state|integer#and': 1,
          'regex:name|string#or': query,
          'in:serviceType|array#and': this.formData.serviceType.join(),
          'nin:_id|array#and': this.formData.bindRelatedIds.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.ServiceResource.data = res.data;
        },
        {
          noload: true
        }
      );
    },
    //新增服务资源
    addSR() {
      this.ServiceResource.ids = [];
      this.ServiceResource.openRelate = true;
    },
    // 添加服务资源
    bindSR() {
      if (!this.ServiceResource.ids) {
        this.osg.toast('请至少选择1个服务资源');
        return;
      }
      this.osg.ajax(
        'basic/serviceTerritoryCustom/bindSR.do',
        {
          stcId: this.formData._id,
          ids: this.ServiceResource.ids.concat(this.formData.bindRelatedIds).join()
        },
        () => {
          this.osg.toast('绑定成功');
          this.getData();
        }
      );
    },
    // 取消当前服务资源绑定
    cancelSR(item, index) {
      this.osg.confirm(`是否确认取消绑定服务资源${item.name}`, () => {
        let arr = [];
        for (let i = 0; i < this.ServiceResource.bindRelatedData.length; i++) {
          let item = this.ServiceResource.bindRelatedData[i];
          if (i != index) {
            arr.push(item._id);
          }
        }
        this.osg.ajax(
          'basic/serviceTerritoryCustom/bindSR.do',
          {
            stcId: this.formData._id,
            ids: arr.join()
          },
          () => {
            this.osg.toast('取消绑定成功');
            this.getData();
          }
        );
      });
    },
    initSTC() {
      this.extendST.show = false;
      this.extendST.ids = [];
    },
    // 搜索服务区域
    searchSTC(query) {
      let arr = this.formData.extendSTCIds.concat([]);
      arr.push(this.formData._id);
      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'regex:name|string#or': query,
          'all:serviceType|array#and': this.formData.serviceType.join(),
          'nin:_id|array#and': arr.join(),
          sortField: 'territoryNum,createTime',
          sortOrder: 'asc'
        },
        res => {
          this.extendST.data = res.data;
        },
        {
          noload: true
        }
      );
    },
    // 新增服务区域
    addSTC() {
      this.extendST.ids = [];
      this.extendST.show = true;
    },
    // 扩充服务区域
    bindSTC() {
      if (!this.extendST.ids) {
        this.osg.toast('请至少选择1个服务区域');
        return;
      }
      this.osg.ajax(
        '/basic/serviceTerritoryCustom/extendSTC.do',
        {
          stcId: this.formData._id,
          ids: this.extendST.ids.concat(this.formData.extendSTCIds).join()
        },
        () => {
          this.osg.toast('扩充成功');
          this.getData();
        }
      );
    },
    // 取消当前扩充服务区域
    cancelSTC(item) {
      this.osg.confirm(`是否确认取消扩充服务区域${item.name}`, () => {
        let arr = this.formData.extendSTCIds;
        arr.splice(arr.indexOf(item._id), 1);
        this.osg.ajax(
          'basic/serviceTerritoryCustom/extendSTC.do',
          {
            stcId: this.formData._id,
            ids: arr.join()
          },
          () => {
            this.osg.toast('取消扩充成功');
            this.getData();
          }
        );
      });
    },
    getExtendSTC() {
      if (this.formData.extendSTCIds.length == 0) {
        this.extendST.extendData = [];
        return;
      }
      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:_id|array#and': this.formData.extendSTCIds.join(),
          sortField: 'territoryNum,createTime',
          sortOrder: 'asc'
        },
        res => {
          this.extendST.extendData = res.data;
        },
        {
          noload: true
        }
      );
    }
    // dragEnd() {
    //   let bindRelatedIds = [];
    //   for (let item of this.ServiceResource.relatedData) {
    //     bindRelatedIds.push(item._id);
    //   }
    //   this.formData.bindRelatedIds = bindRelatedIds;
    //   this.doSave();
    // }
  }
};
</script>
<style lang="scss" scoped>
/*个人信息*/
.box-left-header-contact {
  border-bottom: 1px solid #dfe3eb;
}
.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-info > * {
  margin: 10px auto;
}
.profile-info > span {
  margin: 0;
  font-weight: 400;
  font-size: 24px;
}
.profile-info ul {
  display: flex;
}
.profile-info ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.profile-info ul li span {
  margin-top: 8px;
  font-size: 12px;
}
/* 快捷按钮 */
.shortcuts button {
  background-color: #eaf0f6;
  border-color: #cbd6e2;
  color: #506e91;
}
.shortcuts button i {
  font-weight: bold;
}
.card-item {
  background: #fff;
}
</style>
